import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class ScrollSnapping {
	constructor(el) {

		this.element 		= el
		this.sections 		= this.element.querySelectorAll('.b-text-and-media-tabs__spacer')
		this.navItems 		= [...this.element.querySelectorAll('.b-text-and-media-tabs__navlink')]
		this.nav			= this.element.querySelector('.b-text-and-media-tabs__navinside')
		this.progressBar 	= this.element.querySelector('.b-text-and-media-tabs__progressbar')
		this.init 			= this.init.bind(this)
		this.destroy 		= this.destroy.bind(this)

		this.init()

	}

	init(){

		if(this.sections.length > 0) {

			this.sections.forEach( (section, index) => {

				const targets = this.navItems.length == 0 ? [section] : [section, this.navItems[index]]

				ScrollTrigger.create({
					trigger: section,
					pin: false,
					// start: 'top 25%',
					start: 'top 2px',
					end: 'bottom bottom',
					toggleClass:{
						targets: targets,
						className: 'visible',
					},
					invalidateOnRefresh: true,
				});

			});

			if(this.progressBar && this.element) {
				const pageProgress = GSAP.to(this.progressBar, { 
					width: '100%',
					ease: 'none',
					scrollTrigger: { 
						trigger: this.element,
						start: 'top top',
						end: 'bottom bottom',
						scrub: 0
					}
				})
			}
		
		}

	}

	destroy() {
		// Kill only ScrollTriggers associated with this instance
		ScrollTrigger.getAll().forEach(trigger => {
			if (trigger.vars.trigger && this.element.contains(trigger.vars.trigger)) {
				trigger.kill();
			}
		});
		
		// Clear GSAP animations
		if (this.progressBar) {
			GSAP.killTweensOf(this.progressBar);
		}
		
		console.log('scroll snapping destroyed');
	}

	clickToggle(event) {

		const inx = this.toggleButtons.indexOf(event.currentTarget)
		const button = this.toggleButtons[inx]

		if(button.classList.contains('toggle__btn--active')){
			return
		}

		// OPEN CLICKED
		button.classList.toggle('toggle__btn--active');
		this.toggle.style.setProperty('--distance', inx );

		if( button.ariaExpanded === 'false' ){
			button.setAttribute('aria-selected', 'true');
		} else {
			button.setAttribute('aria-selected', 'false');
		}

		this.closeSiblingToggles(button,this.toggleButtons)

	}

	closeSiblingToggles(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove('toggle__btn--active');
			}
		}
	}

}
